import * as React from 'react'
import {useLocation} from 'react-router-dom'

import {
  useIsAgentsPartSelected,
  getIsChangesSelected,
  useIsGuidesOverviewSelected,
  getIsQueueSelected,
} from '../../../../../hooks/routes'
import {getIsSakuraUI} from '../../../../../selectors'
import {LINKS} from '../../Header.consts'
import HeaderLinkHost from '../LinkHost/LinkHost'
import {isActiveClassicUILink} from '../Links.utils'

import {useAppSelector} from 'src/hooks/react-redux'

function ProjectsLink() {
  const location = useLocation()
  const agentsPartSelected = useIsAgentsPartSelected()
  const queuePartSelected = getIsQueueSelected(location.pathname)
  const changesPartSelected = getIsChangesSelected(location.pathname)
  const guidesOverviewSelected = useIsGuidesOverviewSelected()
  const isSakuraUI = useAppSelector(getIsSakuraUI)
  const active = React.useMemo(
    () =>
      isSakuraUI
        ? !agentsPartSelected &&
          !queuePartSelected &&
          !changesPartSelected &&
          !guidesOverviewSelected
        : isActiveClassicUILink('projects'),
    [
      isSakuraUI,
      agentsPartSelected,
      queuePartSelected,
      changesPartSelected,
      guidesOverviewSelected,
    ],
  )
  return (
    <HeaderLinkHost active={active} title={'Projects'} to={LINKS.overview} icon="project-20px">
      {'Projects'}
    </HeaderLinkHost>
  )
}
export default React.memo(ProjectsLink)
